import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';

import { IEventMonth, ICalendarState } from '@adage/ace-calendar';
import GridCell from '../components/grid-cell';
import ListMonth from './list-month';
import { IArenaEvent } from '../classes/event';
import { ICalendar, IDay } from '@adage/calendar/services/calendar';

export interface ListViewRowExternalProps {
    allEvents: Array<ICalendar<IArenaEvent>>;
}

type ListViewRowProps = ListViewRowExternalProps;

const listView: React.SFC<ListViewRowProps> = (props) => {
    // Grid Cell checks for date validity.
    const today = moment().clone();
    const beginningOfWeek = moment().startOf("week");
    return (
        <section className="list-month list-month-js">
            <div className="grid-month-days">
                {
                    props.allEvents.map((month, idx) => <ListMonth key={idx} allEvents={month.days} />)
                }
            </div>
        </section>
    );
}

export default listView;


// WEBPACK FOOTER //
// ./app/calendar/views/list-view.tsx